import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { dsDtos } from '@vectronic/openApi-admin';
import { CardComponent } from '../../components/card/card.component';

@Component({
  selector: 'vectronic-disabled-subsystems-dialog',
  templateUrl: './disabled-subsystems-dialog.component.html',
  styleUrls: ['./disabled-subsystems-dialog.component.scss'],
  imports: [CardComponent],
})
export class DisabledSubsystemsDialogComponent {
  data: {
    subsystems: dsDtos.Subsystem[];
    disabledSubsystems: boolean[];
    idDevice: number;
    deviceClassName: string;
  } = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<DisabledSubsystemsDialogComponent>);

  getTitle() {
    return `${this.data.deviceClassName || 'Device'} ${this.data.idDevice} - Disabled subsystems`;
  }

  get disabledSubsystemNames(): string[] {
    return (
      this.findFalseIndexes(this.data.disabledSubsystems)
        ?.map(
          (disabledId) =>
            this.data.subsystems?.find(({ identifier }) => identifier === disabledId)?.name,
        )
        .filter((name) => !!name) ?? []
    );
  }
  findFalseIndexes(array: boolean[]) {
    return array
      ?.map((element, index) => {
        if (!element) return index;
      })
      .filter((index) => index !== undefined);
  }
}
